import { createFileRoute } from '@tanstack/react-router';
import AllDossiers from '../../../features/dossiers/list/allDossiers';
import {
  createPermissionGuard,
  DOSSIER_PERMISSIONS,
  getPermissionSet,
} from '@bmwe/ui';

export const Route = createFileRoute('/vorgaenge/(listen)/alle')({
  component: AllDossiers,
  beforeLoad: createPermissionGuard(
    getPermissionSet(DOSSIER_PERMISSIONS, 'READ'),
  ),
});

export const ListAllDossiersRoute = Route;
